export default "__VITE_ASSET__B3tV7r0N__"